<template lang="pug">
div
  nuxt-link.af24__logo(v-if="!isCabinet" :to="`/${$i18n.locale}`", :title="$t('msgs.toMain')", ref="logo", style="position:relative;")
    // img(v-if="!isGe" width="18" height="18" alt="" :src="hearts" style="position: absolute;left: 2.4rem;" :style="{ 'top': isMobile ? '-1rem' : '0' }")
    .af24__logo__image(ref="logo_image")
  a.af24__logo(v-if="isCabinet", :title="$t('msgs.toMain')", ref="logoCab")
    .af24__logo__image(ref="logo_imageCab")
</template>

<script>
export default {
  name: 'AfishaLogo',
  data: () => ({
    isBel: true,
    isCabinet: false,
    win: null,
    isMobile: false,
    isGe: false,
  }),
  computed: {
    hearts() {
      return require('./images/hearts.png').default;
    }
  },
  mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
    let isGe = window.location.hostname.includes('guru.ge');
    this.isGe = isGe;
    if (window.location.hostname.includes('cabinet')) {
      this.isCabinet = true;
      setTimeout(() => {
        this.$refs.logoCab.setAttribute('href', isGe ? 'https://guru.ge' : `https://24afisha.by/${this.$i18n.locale}`);
        this.$refs.logo_imageCab.classList.add(isGe ? 'logoGeo' : 'logoBel');
      }, 250)
    } else {
      if (isGe) {
        this.$refs.logo_image.classList.add('logoGeo');
      } else {
        this.$refs.logo_image.classList.add('logoBel');
      }
    }

  },
};
</script>

<style lang="scss" src="./_.scss"></style>

<style lang="scss">
.logoBel { background-image: url('./images/white/new24afisha.svg') }
.logoGeo { background-image: url('./images/georgia.png') }
// .af24__logo__image { background-image: url('./images/dark/24afisha.svg') }
.white .af24__logo__image {
  background-size: contain;
  height: 1.9rem;
}
</style>
